import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toMutableList20rdgwi7d3cwi as toMutableList,
  plus20p0vtfmu0596 as plus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { toInt2q8uldh7sc951 as toInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  over21zrvdp2w0cyt as over,
  enterxt1o6yqg45ty as enter,
  exit1trjmdna0ewg5 as exit,
  end238hqoddg8oh0 as end,
  DropTargetDelegatede6k5xrbmghq as DropTargetDelegate,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/DropTargetDelegate.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import { LIST_getInstance2vniy0f7mmb29 as LIST_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { listElement3jy3tr2z6og1q as listElement } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { SortPartSerializerr929bckmbnab as SortPartSerializer } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortPartSerializer.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { subrendererSelector1yvbedolu35d3 as subrendererSelector } from './helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_shown_$ref_kipsub2u3yvjqlogkp3 as TextView$_get_shown_$ref_kipsub,
  TextView$_set_shown_$ref_l7jsq921p8dnwznnah1 as TextView$_set_shown_$ref_l7jsq9,
} from './CsvRenderer.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_scrollingHorizontally27coz76tiofr2 as get_scrollingHorizontally } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { lensByElementAssumingSetNeverManipulates1yt8q6qtxcnsa as lensByElementAssumingSetNeverManipulates } from '../../../../../reactive/com/lightningkite/reactive/lensing/LensByElementAssumingSetNeverManipulates.mjs';
import { CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  text189ciz0cnr32o as text,
  h42yee57ysxgrns as h4,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { DragData2helsigoeiabk as DragData } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/DragData.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { flattenml92kmikh8fo as flatten } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { forEachUpdating3is0lusemmftw as forEachUpdating } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/foreach.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import { textPopover3tarprbgmgxbr as textPopover } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function HorizontalListRenderer$form$lambda$o$drop$slambda(this$0, $value, $otherOldIndex) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.$itemLens_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = (yield* await_0(this_0, $completion)).get_index_it478p_k$();
    var myOldIndex = yield* await_1(this_1, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $value;
    // Inline function 'kotlin.let' call
    var it = yield* await_0(this_2, $completion);
    var t = toMutableList(it);
    var otherCol = t.removeAt_6niowx_k$($otherOldIndex);
    if (myOldIndex < $otherOldIndex) {
      t.add_dl6gt3_k$(myOldIndex, otherCol);
    } else {
      t.add_dl6gt3_k$(myOldIndex, otherCol);
    }
    yield* $value.set_revjhg_k$(t, $completion);
    return Unit_instance;
  }), 1);
}
var HorizontalListRenderer$form$1$1Class;
function HorizontalListRenderer$form$1$1() {
  if (HorizontalListRenderer$form$1$1Class === VOID) {
    class $ {
      constructor($value, $mimeType, $this_row, $itemLens) {
        this.$value_1 = $value;
        this.$mimeType_1 = $mimeType;
        this.$this_row_1 = $this_row;
        this.$itemLens_1 = $itemLens;
      }
      drop_tc4way_k$(event) {
        var tmp0_safe_receiver = event.data_1.get_6bo4tg_k$(this.$mimeType_1);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var otherOldIndex = toInt(tmp0_safe_receiver);
          launch(this.$this_row_1, VOID, VOID, HorizontalListRenderer$form$lambda$o$drop$slambda(this, this.$value_1, otherOldIndex));
          tmp = true;
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
      }
    }
    protoOf($).over_pubgvv_k$ = over;
    protoOf($).enter_5nrpdt_k$ = enter;
    protoOf($).exit_1yalkr_k$ = exit;
    protoOf($).end_keguu6_k$ = end;
    initMetadataForClass($, VOID, VOID, VOID, [DropTargetDelegate()]);
    HorizontalListRenderer$form$1$1Class = $;
  }
  return HorizontalListRenderer$form$1$1Class;
}
function RowOrCol$_get_dragData_$ref_o0xagt(p0) {
  return constructCallableReference(() => p0.get_dragData_pas5on_k$(), 0, 0, 170, VOID, [p0]);
}
function RowOrCol$_set_dragData_$ref_8h6jwp(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_dragData_xdzgsz_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 171, VOID, [p0]);
}
function HorizontalListRenderer$form$lambda$lambda$slambda($itemLens, $value) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $itemLens;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = (yield* await_0(this_0, $completion)).get_index_it478p_k$();
    var i = yield* await_1(this_1, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $value;
    // Inline function 'kotlin.collections.filterIndexed' call
    var tmp0 = yield* await_0(this_2, $completion);
    // Inline function 'kotlin.collections.filterIndexedTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      if (!(checkIndexOverflow(_unary__edvuaz) === i)) {
        destination.add_utx5q5_k$(item);
      }
    }
    yield* $value.set_revjhg_k$(destination, $completion);
    return Unit_instance;
  }), 0);
}
function HorizontalListRenderer$form$lambda$slambda($value, $elementSerializer) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $value;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    yield* $value.set_revjhg_k$(plus(tmp$ret$0, default_0($elementSerializer)), $completion);
    return Unit_instance;
  }), 0);
}
var HorizontalListRendererClass;
function HorizontalListRenderer() {
  if (HorizontalListRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Horizontal List';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_x323j5_k$(context, module_0) {
        if (!equals(context.serializer_1.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), LIST_getInstance()))
          return -1.0;
        if (context.hasAnnotation_cpsd4h_k$('com.lightningkite.services.data.HorizontalLayout'))
          return 1.5;
        var elementSerializer = listElement(context.serializer_1);
        if (elementSerializer instanceof SortPartSerializer())
          return 1.2;
        return 0.5;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_x323j5_k$(context, module_0);
      }
      form_pqm97q_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          var tmp = listElement(context.serializer_1);
          var elementSerializer = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : THROW_CCE();
          var elementContext = new (RenderContext())(elementSerializer);
          var elementRenderers = module_0.selectAll_bhj9zi_k$(elementContext);
          var selectedRenderer = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(module_0.selectWithOverride_muco3f_k$(elementContext));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_gap_jwjroq_k$(get_px(0));
          if (module_0.enableRendererSwitching_1) {
            subrendererSelector(element, selectedRenderer, elementRenderers);
          }
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_shown_$ref_kipsub(element_0);
          var tmp_2 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, TextView$_set_shown_$ref_l7jsq9(element_0));
          element_0.invoke_bnq13k_k$(tmp_2, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value).isEmpty_y1axqb_k$());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_3 = element_0.native_1;
          var tmp_4;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength('Empty') === 0) {
            tmp_4 = '\xA0';
          } else {
            tmp_4 = 'Empty';
          }
          tmp_3.set_content_i5lrjv_k$(tmp_4);
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_0 = get_scrollingHorizontally(element);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_0.willAddChild_hz2iwc_k$(element_1);
          element_1.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (RowOrCol())(element_1.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          element_1.willAddChild_hz2iwc_k$(element_2);
          element_2.set_vertical_nuap32_k$(false);
          var tmp_5 = lensByElementAssumingSetNeverManipulates(value);
          forEachUpdating(element_2, tmp_5, VOID, VOID, ($this$forEachUpdating, itemLens) => {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            var this_0 = themed($this$forEachUpdating, CardSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
            ensureOutermostElement(element);
            this_0.willAddChild_hz2iwc_k$(element);
            element.set_vertical_nuap32_k$(false);
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            var mimeType = 'x-lskui/' + elementSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$().toLowerCase();
            text(get_centered(element), '::');
            var tmp = KMutableProperty0();
            var tmp_0 = RowOrCol$_get_dragData_$ref_o0xagt(element);
            var tmp_1 = getPropertyCallableRef('dragData', 0, tmp, tmp_0, RowOrCol$_set_dragData_$ref_8h6jwp(element));
            element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
              var index = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(itemLens).get_index_it478p_k$());
              return DragData().new_com_lightningkite_kiteui_models_DragData_uulv8r_k$('Item ' + (index + 1 | 0), mimeType, index.toString());
            });
            element.set_dropTargetDelegate_92bhjh_k$(new (HorizontalListRenderer$form$1$1())(value, mimeType, element, itemLens));
            // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_0 = new (Frame())(element.get_context_h02k06_k$());
            ensureOutermostElement(element_0);
            element.willAddChild_hz2iwc_k$(element_0);
            var $this$frame = element_0;
            reactive($this$frame, VOID, ($this$reactive) => {
              $this$frame.clearChildren_eufjq4_k$();
              $this$reactive.invoke_r7m7el_k$(selectedRenderer).cellForm_4mayde_k$(elementContext, flatten(itemLens), module_0)($this$frame);
              return Unit_instance;
            });
            element_0.onStartup_vrxh3i_k$();
            element.addChild_2qpft2_k$(element_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (Button())(element.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            element.willAddChild_hz2iwc_k$(element_1);
            var tmp0 = get_centered(element_1);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().close_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_2 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_2);
            tmp0.willAddChild_hz2iwc_k$(element_2);
            element_2.set_source_3o5lkf_k$(icon);
            element_2.set_description_s1386w_k$('Remove');
            element_2.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_2);
            onClick(element_1, VOID, VOID, VOID, HorizontalListRenderer$form$lambda$lambda$slambda(itemLens, value));
            element_1.onStartup_vrxh3i_k$();
            element.addChild_2qpft2_k$(element_1);
            element.onStartup_vrxh3i_k$();
            this_0.addChild_2qpft2_k$(element);
            return Unit_instance;
          });
          element_2.onStartup_vrxh3i_k$();
          element_1.addChild_2qpft2_k$(element_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_3 = new (Button())(element_1.get_context_h02k06_k$());
          ensureOutermostElement(element_3);
          element_1.willAddChild_hz2iwc_k$(element_3);
          var tmp0 = get_centered(element_3);
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          var icon = Companion_getInstance().add_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_4 = new (IconView())(tmp0.get_context_h02k06_k$());
          ensureOutermostElement(element_4);
          tmp0.willAddChild_hz2iwc_k$(element_4);
          element_4.set_source_3o5lkf_k$(icon);
          element_4.set_description_s1386w_k$('Add');
          element_4.onStartup_vrxh3i_k$();
          tmp0.addChild_2qpft2_k$(element_4);
          onClick(element_3, VOID, VOID, VOID, HorizontalListRenderer$form$lambda$slambda(value, elementSerializer));
          element_3.onStartup_vrxh3i_k$();
          element_1.addChild_2qpft2_k$(element_3);
          element_1.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_pqm97q_k$(context, value, module_0);
      }
      view_4nprpb_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          var tmp = listElement(context.serializer_1);
          var elementSerializer = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : THROW_CCE();
          var elementContext = new (RenderContext())(elementSerializer);
          var elementRenderers = module_0.selectAll_bhj9zi_k$(elementContext);
          var selectedRenderer = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(module_0.selectWithOverride_muco3f_k$(elementContext));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_gap_jwjroq_k$(get_px(0));
          if (module_0.enableRendererSwitching_1) {
            subrendererSelector(element, selectedRenderer, elementRenderers);
          }
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_shown_$ref_kipsub(element_0);
          var tmp_2 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, TextView$_set_shown_$ref_l7jsq9(element_0));
          element_0.invoke_bnq13k_k$(tmp_2, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value).isEmpty_y1axqb_k$());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_3 = element_0.native_1;
          var tmp_4;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength('Empty') === 0) {
            tmp_4 = '\xA0';
          } else {
            tmp_4 = 'Empty';
          }
          tmp_3.set_content_i5lrjv_k$(tmp_4);
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_0 = get_scrollingHorizontally(element);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_0.willAddChild_hz2iwc_k$(element_1);
          element_1.set_vertical_nuap32_k$(false);
          forEachUpdating(element_1, value, VOID, VOID, ($this$forEachUpdating, itemValue) => {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
            var this_0 = themed($this$forEachUpdating, CardSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element = new (Frame())(this_0.get_context_h02k06_k$());
            ensureOutermostElement(element);
            this_0.willAddChild_hz2iwc_k$(element);
            var $this$frame = element;
            reactive($this$frame, VOID, ($this$reactive) => {
              $this$frame.clearChildren_eufjq4_k$();
              $this$reactive.invoke_r7m7el_k$(selectedRenderer).cellView_2dvin1_k$(elementContext, itemValue, module_0)($this$frame);
              return Unit_instance;
            });
            element.onStartup_vrxh3i_k$();
            this_0.addChild_2qpft2_k$(element);
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_4nprpb_k$(context, value, module_0);
      }
      cellView_r7nadb_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => '' + $this$invoke.invoke_r7m7el_k$(value).get_size_woubt6_k$() + ' items');
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_r7nadb_k$(context, value, module_0);
      }
      columnWidth_k7iu8b_k$(context, module_0) {
        return 15.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_k7iu8b_k$(context, module_0);
      }
      labeledForm_l8116o_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          h4(element_0, label);
          var tmp0_safe_receiver = description;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var tmp0 = textPopover(get_centered(element_0), tmp0_safe_receiver);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          HorizontalListRenderer_instance.form_pqm97q_k$(context, value, module_0)(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_l8116o_k$(context, value, module_0, label, description);
      }
      labeledView_h6ebjv_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          h4(element_0, label);
          var tmp0_safe_receiver = description;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var tmp0 = textPopover(get_centered(element_0), tmp0_safe_receiver);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          HorizontalListRenderer_instance.view_4nprpb_k$(context, value, module_0)(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_h6ebjv_k$(context, value, module_0, label, description);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    initMetadataForObject($, 'HorizontalListRenderer', VOID, VOID, [Renderer()]);
    HorizontalListRendererClass = $;
  }
  return HorizontalListRendererClass;
}
var HorizontalListRenderer_instance;
function HorizontalListRenderer_getInstance() {
  return HorizontalListRenderer_instance;
}
//region block: init
HorizontalListRenderer_instance = new (HorizontalListRenderer())();
//endregion
//region block: exports
export {
  HorizontalListRenderer_instance as HorizontalListRenderer_instancedxsynz7fbq8d,
  RowOrCol$_get_dragData_$ref_o0xagt as RowOrCol$_get_dragData_$ref_o0xagtn4q7rl2piu2l,
  RowOrCol$_set_dragData_$ref_8h6jwp as RowOrCol$_set_dragData_$ref_8h6jwpayaqli0s9chk,
};
//endregion

//# sourceMappingURL=HorizontalListRenderer.mjs.map
